import React, { useEffect, useState } from 'react'
import { format } from 'date-fns'

function toUtc(d: Date): Date {
  return new Date(d.getTime() + d.getTimezoneOffset() * 60000)
}

type LocalDateTimeProps = {
  date: Date | number
  pattern: string
}

const LocalDateTime = ({ date, pattern }: LocalDateTimeProps) => {
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    setMounted(true)
  }, [])

  const d = typeof date === 'number' ? new Date(date) : date

  if (!mounted) {
    return <>{format(toUtc(d), pattern) + ' UTC'}</>
  }

  return <>{format(d, pattern)}</>
}

export default LocalDateTime
